import type { IWebhookSubscriptionTableModel } from "app/pages/sales-intelligence/modules/signals-api-webhook/types/row-data";

const validateIsSubscriptionComplete = ({
    callbackUrl,
    signalsPerHook,
    signalTypes,
}: IWebhookSubscriptionTableModel): boolean => {
    return Boolean(callbackUrl && signalsPerHook && signalTypes && signalTypes.length);
};

export default validateIsSubscriptionComplete;
